// @flow
import React, { useEffect } from 'react';
// Connectors
import { displayVariantsByPageAndSectionConnector } from '../../products';
// Components
import BlackFridayProductList from '../components/BlackFridayProductList';
// Types
import type { Product } from '../../products/types/index';

type Props = {
  findDisplayVariantsByPageAndSection: (
    page: string,
    section: string,
  ) => Product[],
  productByPageAndSection: (page: string, section: string) => Product[],
};

const BurgerShop = ({
  productByPageAndSection,
  findDisplayVariantsByPageAndSection,
}: Props) => {
  const sliderProductsVariants = productByPageAndSection(
    'black_friday',
    'slider',
  );
  const productsListVariants = productByPageAndSection(
    'black_friday',
    'product_list',
  );
  useEffect(() => {
    findDisplayVariantsByPageAndSection('black_friday');
    //eslint-disable-next-line
  }, []);

  return (
    <div>
      <BlackFridayProductList
        title="OS MAIS PEDIDOS :"
        sliderProductsVariants={sliderProductsVariants}
        productsVariants={productsListVariants}
        currentLanding="black_friday"
      />
    </div>
  );
};
export default displayVariantsByPageAndSectionConnector(BurgerShop);
